import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SvgProgramming from '../components/svg/SvgProgramming';
import { IconClick } from '@tabler/icons-react';
import axios from 'axios';

function ProjeDetay() {
    const { slug } = useParams();
    const [project, setProject] = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        async function fetchProject() {
            try {
                const response = await axios.get("https://admin.maviada.co/api/proje");
                const data = response.data?.data || response.data; // farklı veri yapıları için kontrol

                const matched = data.find(p =>
                    (p.slug || p.title.toLowerCase().replace(/\s+/g, '-')) === slug
                );

                if (matched) {
                    setProject(matched);
                } else {
                    setNotFound(true);
                }
            } catch (err) {
                console.error("Proje verisi alınamadı:", err);
                setNotFound(true);
            }
        }

        fetchProject();
    }, [slug]);

    if (notFound) {
        return <div className="container mt-5"><h2>Proje bulunamadı</h2></div>;
    }

    if (!project) {
        return <div className="container mt-5"><p>Yükleniyor...</p></div>;
    }

    return (
        <div className='hero page-wrapper'>
            <section className='hero'>
                <Container>
                    <Row className="justify-content-center">
                        <Col md={7} lg={6}>
                            <h4 className='mb-3 text-uppercase breadcrumb-text'>ANASAYFA / {project.title}</h4>
                            <h2 className='mb-3 text-uppercase'>{project.title}</h2>
                            <p dangerouslySetInnerHTML={{ __html: project.subtitle }}></p>
                        </Col>
                        <Col md={5} lg={4}>
                            <div className='about-icon'>
                                {project.image && (
                                    <img style={{ width: '50%' }} src={project.image.startsWith("http") ? project.image : `https://admin.maviada.co${project.image}`} alt={project.title} />
                                )}
                            </div>
                        </Col>
                        <Col lg={10}>
                            <div className='red-wrapper' dangerouslySetInnerHTML={{ __html: project.text }}></div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default ProjeDetay;
